import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SuperadminRegister from './pages/SuperadminRegister';
import SuperadminLogin from './pages/SuperadminLogin';
import Dashboard from './pages/Dashboard';
import DeviceList from './pages/DeviceList';
import DeviceForm from './pages/DeviceForm';
import CompanyList from './pages/CompanyList';
import CompanyForm from './pages/CompanyForm';
import AssignDevicesPage from './pages/AssignDevicesPage';
import ConfigureDevice from './pages/ConfigureDevice';
import ProtectedRoute from './components/ProtectedRoute';
import ViewAssignedDevicesPage from './pages/ViewAssignedDevicesPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SuperadminRegister />} />
        <Route path="/login" element={<SuperadminLogin />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/devices"
          element={
            <ProtectedRoute>
              <DeviceList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/devices/create"
          element={
            <ProtectedRoute>
              <DeviceForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/devices/edit/:deviceId"
          element={
            <ProtectedRoute>
              <DeviceForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/devices/configure/:deviceId"
          element={
            <ProtectedRoute>
              <ConfigureDevice />
            </ProtectedRoute>
          }
        />

        <Route
          path="/companies"
          element={
            <ProtectedRoute>
              <CompanyList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/companies/create"
          element={
            <ProtectedRoute>
              <CompanyForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/companies/edit/:companyId"
          element={
            <ProtectedRoute>
              <CompanyForm />
            </ProtectedRoute>
          }
        />

        <Route path="/companies/:company_id/assign-devices" element={<ProtectedRoute><AssignDevicesPage /></ProtectedRoute>} />


<Route path="/companies/:company_id/view-devices" element={<ProtectedRoute><ViewAssignedDevicesPage /></ProtectedRoute>} />


        

      </Routes>
    </Router>
  );
}

export default App;
